import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=6b912f02&scoped=true&"
import script from "./WidgetList.vue?vue&type=script&lang=js&"
export * from "./WidgetList.vue?vue&type=script&lang=js&"
import style0 from "./WidgetList.vue?vue&type=style&index=0&id=6b912f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b912f02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b912f02')) {
      api.createRecord('6b912f02', component.options)
    } else {
      api.reload('6b912f02', component.options)
    }
    module.hot.accept("./WidgetList.vue?vue&type=template&id=6b912f02&scoped=true&", function () {
      api.rerender('6b912f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetList.vue"
export default component.exports